import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import {OpcaoConfirmacao} from './opcao-confirmacao-model'
import {SituacaoConfirmacaoService} from './situacao-confirmacao.service'

/**
 * Serviço de confirmação que permite abrir o modal de confirmação
 */
@Injectable()
export class ConfirmacaoModalService 
{

  constructor(private modalService: NgbModal, private state: SituacaoConfirmacaoService) {}

  /**
   * Abre janela de confirmação
   * @param opcoes (titulo and mensagem)
   * @returns {Promise<any>} 
   */
  confirmar(opcoes: OpcaoConfirmacao): Promise<any> 
  {
    this.state.opcoes = opcoes;
    this.state.modal = this.modalService.open(this.state.template);
    return this.state.modal.result;
  }
}
